var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pivot-header-cell",
      class: _vm.headerClass,
      style: _vm.headerStyle,
    },
    [
      _c("div", { staticClass: "header-content" }, [
        _vm.expandable
          ? _c(
              "i",
              {
                staticClass: "material-icons expand-icon",
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggle-expand")
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.expanded ? "expand_more" : "chevron_right") +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "header-label" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
        _vm._v(" "),
        _vm.sortable
          ? _c(
              "i",
              {
                staticClass: "material-icons sort-icon",
                on: {
                  click: function ($event) {
                    return _vm.$emit("sort")
                  },
                },
              },
              [_vm._v("\n            " + _vm._s(_vm.sortIcon) + "\n        ")]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }